import React from 'react'
import '@loyal_template/placeholder.css'

import image from '@loyal_images/products/placeholder.svg'
const DoubleSliderPlaceholder = () => (
  <div className='container-slider pos-relative bg-white'>
    <div className='row align-items-center h-100 txt-center'>
      <img
        src={image}
        alt='Banner carregando'
        className='img-w-auto ml-auto mr-auto'
      />
    </div>
  </div>
)

export default DoubleSliderPlaceholder



// WEBPACK FOOTER //
// ./src/features/Slider/doubleSlider/DoubleSliderPlaceholder.js